import React from 'react';
import { ConfigurationCanvasContext } from '../ConfigurationCanvasContext';
import { useConfigurationCanvasState } from '../useConfigurationCanvasState';

// Public API for the pages
export const useConfigurationCanvas = () => {
  const context = React.useContext(ConfigurationCanvasContext);
  const { canvasFunnelMap } = useConfigurationCanvasState();
  const { canvasCrmOrgId } = context;

  if (!context) {
    throw new Error('useConfigurationCanvas must be used within a ConfigurationCanvasProvider');
  }
  if (!canvasFunnelMap) {
    throw new Error(
      'canvasFunnelMap must be provided. Please do not use this hook outside of a page',
    );
  }

  return {
    canvasCrmOrgId,
    canvasFunnelMap,
  };
};
